import IdleJs from 'idle-js'
import { setIdleInstance } from './idleController'

export default {
    install(Vue, options) {
        const {
            router,
            store,
            moduleName = 'idle',
            idleTime = 1000,
            events = ['mousemove', 'keydown', 'mousedown', 'touchstart'],
            keepTracking = true,
            startAtIdle = false
        } = options || {}

        if (!store) {
            throw Error('`store` must be passed in options')
        }

        store && store.registerModule(moduleName, {
            state: {
                isIdle: startAtIdle,
                time: 0
            },
            mutations: {
                [`${moduleName}/IDLE_CHANGED`]: function(state, isIdle) {
                    state.isIdle = isIdle
                },
                [`${moduleName}/INCREASE_TIME`]: function(state) {
                    state.time += 1000
                },
                [`${moduleName}/RESTART_TIME`]: function(state) {
                    state.isIdle = false
                    state.time = 0
                }
            }
        })

        const idle = new IdleJs({
            idle: idleTime,
            events,
            keepTracking,
            startAtIdle,

            onIdle() {
                store && store.commit(`${moduleName}/IDLE_CHANGED`, true)
                const timerIdle = setInterval(() => {
                    if (!store.state[moduleName].isIdle) clearInterval(timerIdle)

                    store.commit(`${moduleName}/INCREASE_TIME`)
                    if (store.state[moduleName].time >= store.state.config.logoffMiliseconds) {
                        clearInterval(timerIdle)

                        // nao contar o tempo nas telas indicadas
                        if (!router.history.current.name.includes('painel')) {
                            store.commit('ADD_ERRO', 'Desconectado por tempo ocioso.', { root: true })
                            store.dispatch('logout', { root: true })
                        } else {
                            store.commit(`${moduleName}/RESTART_TIME`)
                        }
                    }
                }, 1000)
            },
            onActive() {
                store && store.commit(`${moduleName}/RESTART_TIME`)
            }
        })

        setIdleInstance(idle)
        Vue.prototype.$idle = idle
    }
}
